'use es6';

import PortalIdParser from 'PortalIdParser';
const PORTAL_ID = PortalIdParser.get();
export const DISMISS_CREATE_AUDIENCE = `ADSUI_DISMISS_CREATE_AUDIENCE:${PORTAL_ID}`;
export const DISMISS_CREATE_DROPDOWN = `ADSUI_DISMISS_CREATE_DROPDOWN:${PORTAL_ID}`;
export const SEEN_A_GOALS_CSAT = `ADSUI_SEEN_A_GOALS_CSAT:${PORTAL_ID}`;
export const PRIVACY_POLICY_KEY = `ADSUI_PRIVACY_POLICY:${PORTAL_ID}`;
export const AUTO_TRACKING_READ_KEY = `ADSUI_WIDGET_AUTOTRACKING_READ_${PORTAL_ID}`;
export const TRACKING_CODE_LINK_CLICKED_KEY = `ADSUI_WIDGET_TRACKINGCODE_LINK_CLICKED_${PORTAL_ID}`;
export const LEGACY_AD_ACCOUNTS_FILTER = `ADSUI_GLOBAL_ACCOUNT_FILTER_${PORTAL_ID}`;
export const GLOBAL_FILTERS = `ADSUI_GLOBAL_FILTERS_${PORTAL_ID}`;
export const DRAFTS_FILTERS = `ADSUI_DRAFTS_FILTERS_${PORTAL_ID}`;
export const MULTI_CURRENCY_COLUMNS_NEW = `ADSUI_MULTI_CURRENCY_COLUMNS_NEW:${PORTAL_ID}`;
export const SEEN_LEAD_AD_DEMO = `ADSUI_LEAD_AD_DEMO_SEEN:${PORTAL_ID}`;
export const SEEN_SEQUENCE_SHEPHERD = `ADSUI_SEEN_SEQUENCE_SHEPHERD:${PORTAL_ID}`;
export const SEEN_ENHANCED_CONVERSION_BANNER = `ADSUI_SEEN_ENHANCED_CONVERSION_BANNER:${PORTAL_ID}`;
export const SEEN_SIMPLE_AUTOMATION_SHEPHERD = `ADSUI_SEEN_SIMPLE_AUTOMATION_SHEPHERD:${PORTAL_ID}`;